<template>
  <div class="menu-container">
    <TransitionGroup name="menu">
      <Menu v-if="menuOpen" :updateReady="updateReady" />
      <Shortcut v-if="shortcutOpen && !menuOpen" />
    </TransitionGroup>
  </div>
</template>

<script>
import Menu from "@/components/sections/menu/Menu.vue";
import Shortcut from "@/components/sections/shortcut/Shortcut.vue";

export default {
  name: "MenuContainer",
  components: {
    Menu,
    Shortcut,
  },
  computed: {
    anyMenuOpen() {
      return this.menuOpen || this.shortcutOpen;
    },
  },
  watch: {
    anyMenuOpen(isOpen, wasOpen) {
      if (isOpen === wasOpen) return;
      if (isOpen) {
        this.$root.saveHeaderState();
      } else {
        this.$root.restoreHeaderState();
      }
    },
  },
  props: {
    menuOpen: {
      type: Boolean,
      required: true,
    },
    shortcutOpen: {
      type: Boolean,
      required: true,
    },
    updateReady: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
<style lang="scss">
// menu anims

.menu-enter-active {
  transition: opacity 0.5s 0.5s ease-out, filter 0.5s 0.5s ease-out,
    transform 1s 0.5s $ease-out-quint;
}

.menu-leave-active {
  transition: opacity 0.5s ease-out, filter 0.5s ease-out,
    transform 0.5s ease-in;

  & > .page__inner > .menu-content-anim::after {
    animation: to-white 0.5s 0s $ease-out-quad both;
  }
}

.menu-enter-from {
  opacity: 0;
  filter: blur($blur);
  transform: scale(0.8);

  @media (prefers-reduced-motion) {
    transform: none;
  }
}

.menu-leave-to {
  opacity: 0;
  filter: blur($blur);
  transform: scale(0.9);

  @media (prefers-reduced-motion) {
    transform: none;
  }
}
</style>
